<template>
  <Preloader v-if="globalLoading" />
  <VRow v-else-if="errorMessage">
    <VCol cols="12">
      <VAlert type="error">
        {{ errorMessage }}
      </VAlert>
    </VCol>
  </VRow>
  <VRow v-else>
    <VCol cols="12">
      <div class="hunticaPopup oAuth d-flex flex-column align-center">
        <div class="logo">
          <div class="i" />
          <div class="text-center">
            {{ $t('slogan') }}
          </div>
        </div>
        <img
          v-if="user.company.logo"
          class="company-logo mb-8"
          :src="user.company.logo.file.url"
        >
        <div class="title d-flex flex-column align-center mb-12">
          <div class="name">
            {{ user.firstName }} {{ user.lastName }}
          </div>
          <div class="company">
            {{ user.company.name }}
          </div>
        </div>
        <p class="text-center">
          {{ $t('application') }} {{ client.name }} {{ $t('requiresAccess') }}
        </p>
        <VBtn class="mt-17 mb-4" :loading="approveLoading" @click="approve">
          {{ $t('approve') }}
        </VBtn>
        <a class="link" @click="deny">{{ $t('deny') }}</a>
        <a class="link" @click="logout">{{ $t('chooseAnotherAccount') }}</a>
      </div>
    </VCol>
  </VRow>
</template>

<script>
import ValidationMixin from '../../mixins/ValidationMixin';
import Preloader from '../../components/Preloader.vue';
import Client from '../../orm/models/Oauth/Client';
import User from '../../orm/models/User/User';

export default {
  name: 'OauthAuthorization',
  components: { Preloader },
  mixins: [ValidationMixin],
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      globalLoading: true,
      client: null,
      approveLoading: false,
      denyLoading: false,
    };
  },
  computed: {
    user() {
      return User.getAuthUser();
    },
  },
  methods: {
    prepare() {
      this.withLoading(async () => {
        await this.fetchClient();
      }, 'globalLoading');
    },
    async fetchClient() {
      await this.withApiErrorHandling(async () => {
        await Client.api().fetchById(this.clientId);
        this.client = Client.query()
          .find(this.clientId);
      }, (e) => {
        this.errorMessage = e.message;
      });
    },
    async approve() {
      await this.withApiErrorHandling(async () => {
        await Client.api().approve(this.$route.query);
      }, (e) => this.$toast.error(e.message), 'approveLoading');
    },
    async deny() {
      await this.withApiErrorHandling(async () => {
        await Client.api().deny(this.$route.query);
      }, (e) => this.$toast.error(e.message), 'denyLoading');
    },
    async logout() {
      await this.withApiErrorHandling(async () => {
        await User.api().logout();
        await this.$store.dispatch('entities/deleteAll');
        await this.$router.push({ name: 'login' });
      }, (e) => this.$toast.error(e.message));
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => vm.prepare());
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.prepare();
  },
};
</script>

<style lang="scss" scoped>
.oAuth {
  width: 640px;
  padding-bottom: 30px;
  margin-left: auto;
  margin-right: auto;
  .logo {
    margin-bottom: 38px;
    .i {
      width: 181px;
      height: 28px;
      background: url(../../assets/img/logo_oAuth.svg) no-repeat center;
      background-size: contain;
      margin: 0 auto 11px;
    }
    div {
      font-size: 12px;
      line-height: 1.17em;
      color: #757575;
    }
  }
  .company-logo {
    width: 60px;
    border: 1px solid rgba(#212121, 0.1);
    box-sizing: border-box;
    border-radius: 4px;
  }
  .title {
    font-size: 14px;
    line-height: 1.43em;
    .company {
      font-size: 12px;
      line-height: 1.67em;
      color: #757575;
    }
  }
}
</style>

<i18n locale="en" lang="yaml">
  authorizationRequest: Authorization request
  application: Application
  requiresAccess: >-
    requires
    access to your account
  deny: Cancel
  approve: Approve
  chooseAnotherAccount: Choose another account
  slogan: >-
    The first automated interview
    service with a real person
</i18n>

<i18n locale="ru" lang="yaml">
  authorizationRequest: Запрос авторизации
  application: Приложение
  requiresAccess: >-
    запрашивает
    разрешение на доступ к вашему аккаунту.
  deny: Отмена
  approve: Разрешить
  chooseAnotherAccount: Выбрать другой аккаунт
  slogan: >-
    Сервис видеособеседований
    с человеческим лицом
</i18n>
